import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {saleEventActions} from "./saleEventSlice";
import {saleApi} from "~/api";

function* fetchSaleEventList(action) {
	try {
		const response = yield call(saleApi.eventGets, action.payload);
		yield put(saleEventActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch saleEvent list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(saleEventActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(saleEventActions.setFilter(action.payload));
}

export default function* saleEventSaga() {
	yield takeLatest(saleEventActions.fetchData.type, fetchSaleEventList);
	yield debounce(500, saleEventActions.setFilterWithDebounce.type, handleSearchDebounce)
}